module.exports = __webpack_public_path__ + "img/container-template.2d42b498.jpg";